export default __webpack_public_path__ + "static/media/js.8442f61d.svg";